// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"77db2cc65e846eaa8e1f","678":"8f4d090364784dd60bdb"}[chunkId] + ".js";
};